export default __webpack_public_path__ + "static/media/03_tag_paid-parking.d7ab8be6.svg";